import * as z from "zod";
import {
  carrierClaimsFilterSchema,
  carrierClaimsGrainSchema,
  carrierClaimsSnapshotGroupBySchema,
} from "./carrier-claims-analytics-common";

export const CARRIER_CLAIMS_SERIES_METRICS = [
  "created",
  "submitted",
  "decided",
  "approved",
  "rejected",
  "redoKeepRevenueUsd",
  "payoutRetainedUsd",
  "carrierPayoutUsd",
] as const;
export const carrierClaimsSeriesMetricSchema = z.enum(
  CARRIER_CLAIMS_SERIES_METRICS,
);
export type CarrierClaimsSeriesMetric = z.infer<
  typeof carrierClaimsSeriesMetricSchema
>;

export const carrierClaimsSeriesPointSchema = z.object({
  bucket: z.string(),
  key: z.string(),
  label: z.string(),
  metric: carrierClaimsSeriesMetricSchema,
  value: z.number(),
});
export type CarrierClaimsSeriesPoint = z.infer<
  typeof carrierClaimsSeriesPointSchema
>;

export const getCarrierClaimsTimeSeries = {
  name: "getCarrierClaimsTimeSeries" as const,
  input: carrierClaimsFilterSchema.extend({
    metrics: z.array(carrierClaimsSeriesMetricSchema).min(1),
    grain: carrierClaimsGrainSchema.optional(),
    groupBy: carrierClaimsSnapshotGroupBySchema.optional(),
  }),
  output: z.object({
    grain: carrierClaimsGrainSchema,
    points: z.array(carrierClaimsSeriesPointSchema),
  }),
};

export type GetCarrierClaimsTimeSeriesInput = z.infer<
  typeof getCarrierClaimsTimeSeries.input
>;
export type GetCarrierClaimsTimeSeriesOutput = z.infer<
  typeof getCarrierClaimsTimeSeries.output
>;
